module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-9-46736486818e187b42b21caac001d3e6.webp";